import React, { ReactElement, ReactNode } from 'react';
import styles from './index.module.css';

export interface LoaderWrapperProps {
  ariaLabel?: string;
  accessibleLoadedMessage?: string;
  accessibleLoadingMessage?: string;
  children: ReactNode;
  show?: boolean;
  className: string;
}

export function LoaderWrapper({
  ariaLabel = 'Loading, please wait...',
  accessibleLoadedMessage = 'Content Loaded',
  accessibleLoadingMessage = 'Content Loading',
  children,
  className,
  show = true,
}: LoaderWrapperProps): ReactElement {
  return (
    <div
      className={className}
      aria-label={ariaLabel}
      role="alert"
      aria-live="assertive"
    >
      {show ? children : null}
      <p className={styles.accessibleMessage}>
        {show ? accessibleLoadingMessage : accessibleLoadedMessage}
      </p>
    </div>
  );
}
